import { Link } from 'react-router';

import { studentCoursePageStudySessionPath } from 'my-core/routes';
import { STUDY_SESSION_TYPES } from 'my-core/study-session-utils';

import Button from '@mui/material/Button';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';

export default function StudySessionBundleCheckoutConfirmation({ course, onClose, studySessionBundle }) {
  const studySessions = studySessionBundle.study_sessions;

  return (
    <div
      css={({ breakpoints, spacing }) => ({
        padding: spacing(2, 8),
        [breakpoints.down('sm')]: { padding: spacing(2) },
      })}
    >
      <Typography sx={{ mb: 3 }} variant="h5">
        Congrats!
      </Typography>
      <Typography gutterBottom>
        You've successfully purchased the {course?.code} {studySessionBundle.title} bundle. You're now registered for
        every grade booster it includes, and we've sent you an email with all the details.
      </Typography>
      <Typography component="ul" sx={{ my: 2, pl: 3 }}>
        {studySessions.map(ss => (
          <li key={ss.id}>
            {course ?
              <MuiLink component={Link} onClick={onClose} to={studentCoursePageStudySessionPath(course, ss)}>
                {ss.title}
              </MuiLink>
            : ss.title}
            {STUDY_SESSION_TYPES[ss.type] && ` — ${STUDY_SESSION_TYPES[ss.type].label}`}
          </li>
        ))}
      </Typography>
      <Button onClick={onClose} sx={{ mt: 2 }} variant="contained">
        Done
      </Button>
    </div>
  );
}
